import { getToken, clearAuth } from './auth';

/**
 * 开发环境建议留空，走 CRA proxy → 同源，无需 CORS 预检。
 * 生产环境在 .env.production 配置 REACT_APP_API_BASE_URL。
 */
const BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

/**
 * 统一请求封装，按 ResponseResult.status 判断业务成败
 * @param {string} url - 路径，如 /api/sys_user/login
 * @param {RequestInit & { skipAuthRedirect?: boolean }} options
 * @returns {Promise<*>} result.data
 */
async function request(url, options = {}) {
    const { skipAuthRedirect = false, headers: customHeaders, ...fetchOptions } = options;

    const headers = {
        'Content-Type': 'application/json',
        ...(customHeaders || {}),
    };

    const token = getToken();
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const fullUrl = `${BASE_URL}${url}`;
    let response;
    try {
        response = await fetch(fullUrl, {
            ...fetchOptions,
            headers,
        });
    } catch (err) {
        if (err?.name === 'AbortError') {
            throw err;
        }
        throw new Error('无法连接服务器，请确认后端已启动且网络正常');
    }

    let result;
    try {
        result = await response.json();
    } catch {
        throw new Error('服务器响应格式错误');
    }

    const status = result.status != null ? String(result.status) : '';

    const fail = (message, code) => {
        const err = new Error(message);
        err.responseStatus = code;
        throw err;
    };

    if (status === '401' && !skipAuthRedirect) {
        clearAuth();
        window.location.href = '/login';
        fail(result.message || '未登录或令牌无效', status);
    }

    if (status === '403') {
        fail(result.message || '无权访问', status);
    }

    if (status === '409') {
        fail(result.message || '资源冲突，请更换后重试', status);
    }

    if (status === '429') {
        fail(result.message || '操作过于频繁，请稍后再试', status);
    }

    if (status === '410') {
        fail(result.message || '该功能已下线，请刷新页面或联系管理员', status);
    }

    if (status !== '200') {
        const fallback =
            response.status >= 500
                ? result.error || '服务器内部错误，请检查扫描路径或联系管理员'
                : '请求失败';
        fail(result.message || fallback, status);
    }

    return result.data;
}

export default request;
